import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { GoToTopComponent } from './go-to-top/go-to-top.component';

@NgModule({
  imports: [CommonModule, FontAwesomeModule],
  declarations: [GoToTopComponent],
  exports: [GoToTopComponent]
})
export class HffCommonUiGoToTopModule {}
